export var IconNameToIconID = {
    EzyVetLogo: 'ezyvet-ss-ezyVet-logo',
    AddressBook: 'ezyvet-ss-address-book',
    AnglesLeft: 'ezyvet-ss-angles-left',
    AnglesRight: 'ezyvet-ss-angles-right',
    ArrowDownShortWide: 'ezyvet-ss-arrow-down-short-wide',
    ArrowRotateLeft: 'ezyvet-ss-arrow-rotate-left',
    ArrowRotateRight: 'ezyvet-ss-arrow-rotate-right',
    ArrowUpFromBracket: 'ezyvet-ss-arrow-up-from-bracket',
    ArrowUpShortWide: 'ezyvet-ss-arrow-up-short-wide',
    ArrowsRotate: 'ezyvet-ss-arrows-rotate',
    Ban: 'ezyvet-ss-ban',
    Barcode: 'ezyvet-ss-barcode',
    Bell: 'ezyvet-ss-bell',
    BookOpen: 'ezyvet-ss-book-open',
    Box: 'ezyvet-ss-box',
    Calculator: 'ezyvet-ss-calculator',
    Calendar: 'ezyvet-ss-calendar',
    CaretDown: 'ezyvet-ss-caret-down',
    CaretLeft: 'ezyvet-ss-caret-left',
    CaretRight: 'ezyvet-ss-caret-right',
    CaretUp: 'ezyvet-ss-caret-up',
    ChartSimple: 'ezyvet-ss-chart-simple',
    Check: 'ezyvet-ss-check',
    ChevronDown: 'ezyvet-ss-chevron-down',
    ChevronLeft: 'ezyvet-ss-chevron-left',
    ChevronRight: 'ezyvet-ss-chevron-right',
    ChevronUp: 'ezyvet-ss-chevron-up',
    Circle: 'ezyvet-ss-circle',
    CircleCheck: 'ezyvet-ss-circle-check',
    CircleExclamation: 'ezyvet-ss-circle-exclamation',
    CircleHalfStroke: 'ezyvet-ss-circle-half-stroke',
    CircleInfo: 'ezyvet-ss-circle-info',
    CirclePlus: 'ezyvet-ss-circle-plus',
    CircleQuestion: 'ezyvet-ss-circle-question',
    CircleStroke: 'ezyvet-ss-circle-stroke',
    CircleXmark: 'ezyvet-ss-circle-xmark',
    Clock: 'ezyvet-ss-clock',
    ClockRotateLeft: 'ezyvet-ss-clock-rotate-left',
    Clone: 'ezyvet-ss-clone',
    Cloud: 'ezyvet-ss-cloud',
    Copy: 'ezyvet-ss-copy',
    Count: 'ezyvet-ss-Count',
    CreditCard: 'ezyvet-ss-credit-card',
    Dolly: 'ezyvet-ss-dolly',
    Download: 'ezyvet-ss-download',
    EllipsisSolid: 'ezyvet-ss-ellipsis-solid',
    EllipsisVertical: 'ezyvet-ss-ellipsis-vertical',
    Envelope: 'ezyvet-ss-envelope',
    Eye: 'ezyvet-ss-eye',
    EyeSlash: 'ezyvet-ss-eye-slash',
    FileExport: 'ezyvet-ss-file-export',
    FileImport: 'ezyvet-ss-file-import',
    FileInvoice: 'ezyvet-ss-file-invoice',
    FloppyDisk: 'ezyvet-ss-floppy-disk',
    Gear: 'ezyvet-ss-gear',
    GraduationCap: 'ezyvet-ss-graduation-cap',
    GripVertical: 'ezyvet-ss-grip-vertical',
    HourglassHalf: 'ezyvet-ss-hourglass-half',
    Link: 'ezyvet-ss-link',
    Lock: 'ezyvet-ss-lock',
    MagnifyingGlass: 'ezyvet-ss-magnifying-glass',
    NotesMedical: 'ezyvet-ss-notes-medical',
    PaperPlane: 'ezyvet-ss-paper-plane',
    Paw: 'ezyvet-ss-paw',
    Pen: 'ezyvet-ss-pen',
    Phone: 'ezyvet-ss-phone',
    Plus: 'ezyvet-ss-plus',
    Print: 'ezyvet-ss-print',
    PuzzlePiece: 'ezyvet-ss-puzzle-piece',
    RectangleList: 'ezyvet-ss-rectangle-list',
    SackDollar: 'ezyvet-ss-sack-dollar',
    Sitemap: 'ezyvet-ss-sitemap',
    Stethoscope: 'ezyvet-ss-stethoscope',
    Stopwatch: 'ezyvet-ss-stopwatch',
    Syringe: 'ezyvet-ss-syringe',
    TableColumns: 'ezyvet-ss-table-columns',
    Tag: 'ezyvet-ss-tag',
    Terminal: 'ezyvet-ss-terminal',
    Trash: 'ezyvet-ss-trash',
    TriangleExclamation: 'ezyvet-ss-triangle-exclamation',
    Unlock: 'ezyvet-ss-unlock',
    UpRightFromSquare: 'ezyvet-ss-up-right-from-square',
    User: 'ezyvet-ss-user',
    Users: 'ezyvet-ss-users',
    Wrench: 'ezyvet-ss-wrench',
    Xmark: 'ezyvet-ss-xmark',
};
//# sourceMappingURL=IconNameToIconIdMap.js.map